import script from "./SearchCandidateLanguages.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchCandidateLanguages.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__